import React from "react";
import { MedicardTemplateProps } from "./types";
import DefaultTemplate from "./templates/DefaultTemplate";
import whitelabelTemplates from "@medicard-templates";

const templateRegistry: Record<string, React.FC<MedicardTemplateProps>> = {
  ...whitelabelTemplates,
};

export const resolveTemplate = (
  templateName?: string
): React.FC<MedicardTemplateProps> | null => {
  if (templateName && templateRegistry[templateName]) {
    return templateRegistry[templateName];
  }
  return null;
};

export default templateRegistry;
